import IntroWizardsCover from '@/components/intro-wizards/intro-wizards-cover/intro-wizards-cover';
import { Text } from '@cmpsr/components';

type ModalIntroWizardCoverProps = {
  onNextButtonClick: () => void;
  onBackButtonClick: () => void;
};

export default function ModalIntroWizardCover(props: ModalIntroWizardCoverProps) {
  return (
    <IntroWizardsCover
      titleNode={
        <Text as="h1" variant="text-header-XL" color="text-light">
          {' '}
          Welcome to your{' '}
          <Text as="span" textStyle="text-header-xl-v" color="text-light !important">
            Action Plan!
          </Text>
        </Text>
      }
      descriptionNode={
        <Text variant={{ base: 'text-body-meta-regular', lg: 'text-body-regular' }} color="text-light">
          Welcome to your Action Plan, where you'll learn the top ways you can reduce your cancer risk, pick what you
          want to focus on, and track your progress over time.
        </Text>
      }
      icon="testing-history-light"
      onNextButtonClick={props.onNextButtonClick}
      onBackButtonClick={props.onBackButtonClick}
    />
  );
}
